export const QA_NAME_MATCH_REQUEST_MODAL = 'matchRequestModal'

export const QA_NAME_MATCH_REQUEST_SUBJECT = 'matchRequestSubject'

export const QA_NAME_MATCH_REQUEST_MESSAGE = 'matchRequestMessage'

export const MATCH_REQUEST_FIELD_NAME_SUBJECT = 'subject'

export const MATCH_REQUEST_FIELD_NAME_MESSAGE = 'message'

export const MATCH_REQUEST_MESSAGE_MIN_ROWS = 8

export const MATCH_REQUEST_FORBIDDEN_PATTERNS = [
  /%/,
  /\beligible\b/i,
  /\bgeeignet\b/i,
  /\bscore\b/i,
  /\bpassung\b/i,
]
